var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { svgIcon } from '../svg-icon';
/**
 * @tdr
 */
export var RemoveOutline = svgIcon(function (props) { return (React.createElement("svg", __assign({}, props, { viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }),
    React.createElement("path", { fill: "currentColor", d: "M10 1.6c4.65 0 8.4 3.8 8.4 8.4 0 4.6-3.75 8.4-8.4 8.4A8.39 8.39 0 0 1 1.6 10c0-4.65 3.75-8.4 8.4-8.4ZM10 0C4.5 0 0 4.5 0 10s4.5 10 10 10 10-4.5 10-10S15.5 0 10 0Z" }),
    React.createElement("path", { fill: "currentColor", d: "m6.3 5.08-1.2 1.2 8.48 8.5 1.2-1.21L6.3 5.08Z" }),
    React.createElement("path", { fill: "currentColor", d: "M13.69 5.12 5.21 13.6l1.06 1.06 8.48-8.48-1.06-1.06Z" }))); });
//# sourceMappingURL=RemoveOutline.js.map